module.exports = __webpack_public_path__ + "static/permissions-285eac295cd8918d42bdedd62f55aa78.png";